const CompanyTypes = {
    FIXEDASSET_ACTION_START:"FIXEDASSET_ACTION_START",
    FIXEDASSET_FETCH_DATA:"FIXEDASSET_FETCH_DATA",
    FIXEDASSET_FETCH_DATA_FAILED:"FIXEDASSET_FETCH_DATA_FAILED",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
}

const FixedAssetReducer = (state=Initial_state, action) => {
    switch(action.type){
        case CompanyTypes.FIXEDASSET_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case CompanyTypes.FIXEDASSET_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload,
            }

        case CompanyTypes.FIXEDASSET_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export default FixedAssetReducer;